import { ShieldCheck, ShieldAlert, ShieldQuestion } from 'lucide-react';
import { cn } from '../lib/utils';

export const TrustBadge = ({ status, size = 'default', showLabel = true }) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'verified':
        return {
          icon: ShieldCheck,
          label: 'Verified',
          className: 'bg-primary text-white border-primary',
        };
      case 'flagged':
        return {
          icon: ShieldAlert,
          label: 'Flagged',
          className: 'bg-destructive text-white border-destructive',
        };
      default:
        return {
          icon: ShieldQuestion,
          label: 'Unverified',
          className: 'bg-sage text-white border-sage',
        };
    }
  };

  const config = getStatusConfig();
  const Icon = config.icon;

  const sizeClasses = {
    small: 'px-2 py-0.5 text-[10px] gap-1',
    default: 'px-3 py-1 text-xs gap-1.5',
    large: 'px-4 py-1.5 text-sm gap-2',
  };

  const iconSizes = {
    small: 'w-3 h-3',
    default: 'w-3.5 h-3.5',
    large: 'w-4 h-4',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full font-bold uppercase tracking-wider border transition-all',
        sizeClasses[size],
        config.className
      )}
      data-testid={`trust-badge-${status}`}
    >
      <Icon className={iconSizes[size]} />
      {showLabel && <span>{config.label}</span>}
    </span>
  );
};

export default TrustBadge;
